import React from "react";
import CrudManager from "../components/CrudManager";
import { api, resolveMediaUrl } from "../../lib/api";

const fields = [
  {
    name: "title",
    label: "Video Title",
    required: true,
    fullWidth: true,
  },
  {
    name: "category",
    label: "Category",
    type: "select",
    options: [
      "School Activities",
      "Events",
      "Academics",
      "Sports",
      "Celebrations",
      "Campus",
      "Other",
    ],
    defaultValue: "School Activities",
    required: true,
  },
  {
    name: "date",
    label: "Date",
    type: "date",
  },
  {
    name: "videoUrl",
    label: "YouTube Video URL",
    type: "url",
    placeholder: "https://www.youtube.com/watch?v=...",
    required: true,
    fullWidth: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    rows: 3,
    fullWidth: true,
  },
  {
    name: "thumbnail.url",
    label: "Thumbnail Image",
    type: "image",
    fullWidth: true,
  },
  {
    name: "thumbnail.alt",
    label: "Thumbnail Alt Text",
  },
  {
    name: "position",
    label: "Display Position",
    type: "number",
    defaultValue: 0,
    min: 0,
  },
  {
    name: "isActive",
    label: "Video Status",
    type: "checkbox",
    defaultValue: true,
    help: "Show on website",
  },
];

export default function VideoGallery() {
  return (
    <CrudManager
      title="Video Gallery"
      singular="Video"
      fields={fields}
      apiResource={api.videos}
      columns={[
        {
          label: "Thumbnail",
          render: (item) =>
            item.thumbnail?.url ? (
              <img
                className="admin-table-image"
                src={resolveMediaUrl(item.thumbnail.url)}
                alt={item.thumbnail.alt || item.title}
              />
            ) : (
              "—"
            ),
        },
        {
          label: "Title",
          accessor: "title",
        },
        {
          label: "Category",
          accessor: "category",
        },
        {
          label: "Video URL",
          render: (item) => (
            <a
              href={item.videoUrl}
              target="_blank"
              rel="noreferrer"
            >
              Open Video
            </a>
          ),
        },
        {
          label: "Status",
          render: (item) => (
            <span
              className={`admin-badge ${
                item.isActive ? "success" : "muted"
              }`}
            >
              {item.isActive ? "Active" : "Hidden"}
            </span>
          ),
        },
      ]}
    />
  );
}